import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AddressModule } from '@shared/address/address.module';
import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';
import { DesktopEntityCardComponent, DesktopSummaryEntityComponent } from './components';

@NgModule({
  declarations: [DesktopSummaryEntityComponent, DesktopEntityCardComponent],
  imports: [CommonModule, MutualModule, AddressModule, PipesSharedModule],
  exports: [DesktopSummaryEntityComponent, DesktopEntityCardComponent],
})
export class EntityMutualModule {}
